/* biome-ignore-all lint/style/noParameterAssign: Need to pass ref for forwardRef */
/* biome-ignore-all lint/performance/noNamespaceImport: Cleaner when working with libraries */
'use client';

import * as Separator from '@radix-ui/react-separator';
import { forwardRef } from 'react';

const Root = forwardRef<
  React.ComponentRef<typeof Separator.Root>,
  React.ComponentPropsWithoutRef<typeof Separator.Root>
>(({ className, children, ...rest }, ref) => (
  <Separator.Root
    className={className}
    ref={ref}
    {...rest}
  >
    {children}
  </Separator.Root>
));
Root.displayName = 'SeparatorRoot';

export { Root };
